import _regeneratorRuntime from "/builds/adn/dashboard-vuejs/node_modules/@babel/runtime/helpers/esm/regeneratorRuntime.js";
import _createForOfIteratorHelper from "/builds/adn/dashboard-vuejs/node_modules/@babel/runtime/helpers/esm/createForOfIteratorHelper.js";
import _asyncToGenerator from "/builds/adn/dashboard-vuejs/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.string.trim.js";
import { login as _login, logout as _logout, getInfoMe as _getInfoMe, renewAuthToken as _renewAuthToken } from '@/api/user';
import { getToken, setToken, removeToken } from '@/utils/auth';
import router, { resetRouter } from '@/router';
var state = {
  token: getToken(),
  name: '',
  ID: '',
  avatar: '',
  introduction: '',
  roles: []
};
var mutations = {
  SET_TOKEN: function SET_TOKEN(state, token) {
    state.token = token;
  },
  SET_INTRODUCTION: function SET_INTRODUCTION(state, introduction) {
    state.introduction = introduction;
  },
  SET_NAME: function SET_NAME(state, name) {
    state.name = name;
  },
  SET_ID: function SET_ID(state, ID) {
    state.ID = ID;
  },
  SET_EMAIL: function SET_EMAIL(state, val) {
    state.email = val;
  },
  SET_AVATAR: function SET_AVATAR(state, avatar) {
    state.avatar = avatar;
  },
  SET_ROLES: function SET_ROLES(state, roles) {
    state.roles = roles;
  }
};
var actions = {
  // user login
  login: function login(_ref, userInfo) {
    var commit = _ref.commit;
    var username = userInfo.username,
      password = userInfo.password;
    return new Promise(function (resolve, reject) {
      _login({
        username: username.trim(),
        password: password
      }).then(function (response) {
        // const { data } = response
        var data = response;
        commit('SET_TOKEN', data.token);
        setToken(data.token);
        resolve();
      }).catch(function (error) {
        reject(error);
      });
    });
  },
  // Renew AuthToken
  renewAuthToken: function renewAuthToken(_ref2) {
    var commit = _ref2.commit;
    return new Promise(function (resolve, reject) {
      _renewAuthToken().then(function (response) {
        // const { data } = response
        var data = response;
        commit('SET_TOKEN', data.token);
        setToken(data.token);
        resolve();
      }).catch(function (error) {
        reject(error);
      });
    });
  },
  // get user info
  getInfoMe: function getInfoMe(_ref3) {
    var commit = _ref3.commit,
      state = _ref3.state;
    return new Promise(function (resolve, reject) {
      _getInfoMe(state.token).then(function (response) {
        var data = response.data;
        // const data = response

        if (!data) {
          reject('Verification failed, please Login again.');
        }
        // NOTE Temporarily
        // data.roles = ['user']
        data.roles = (data.RoleNames || []).concat(['user']);
        data.avatar = '';
        data.name = data.Username;
        data.email = data.Email;
        if (data.Freezed) {
          data.roles = [];
        }
        var roles = data.roles,
          name = data.name,
          ID = data.ID,
          email = data.email,
          avatar = data.avatar,
          introduction = data.introduction;

        // roles must be a non-empty array
        if (!roles || roles.length <= 0) {
          reject('getInfoMe: roles must be a non-null array!');
        }
        commit('SET_ROLES', roles);
        commit('SET_NAME', name);
        commit('SET_ID', ID);
        commit('SET_EMAIL', email);
        commit('SET_AVATAR', avatar);
        commit('SET_INTRODUCTION', introduction);
        resolve(data);
      }).catch(function (error) {
        reject(error);
      });
    });
  },
  // user logout
  logout: function logout(_ref4) {
    var commit = _ref4.commit,
      state = _ref4.state;
    return new Promise(function (resolve, reject) {
      _logout(state.token).then(function () {
        commit('SET_TOKEN', '');
        commit('SET_ROLES', []);
        removeToken();
        resetRouter();
        resolve();
      }).catch(function (error) {
        reject(error);
      });
    });
  },
  // remove token
  resetToken: function resetToken(_ref5) {
    var commit = _ref5.commit;
    return new Promise(function (resolve) {
      commit('SET_TOKEN', '');
      commit('SET_ROLES', []);
      commit('SET_NAME', '');
      commit('SET_ID', '');
      commit('SET_EMAIL', '');
      commit('SET_AVATAR', '');
      commit('SET_INTRODUCTION', '');
      removeToken();
      resolve();
    });
  },
  // Dynamically modify permissions
  changeRoles: function changeRoles(_ref6, role) {
    var commit = _ref6.commit,
      dispatch = _ref6.dispatch;
    return /*#__PURE__*/_asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
      var token, _yield$dispatch, roles, accessRoutes, _iterator, _step, accessRoute;
      return _regeneratorRuntime().wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            token = role + '-token';
            commit('SET_TOKEN', token);
            setToken(token);
            _context.next = 5;
            return dispatch('getInfoMe');
          case 5:
            _yield$dispatch = _context.sent;
            roles = _yield$dispatch.roles;
            resetRouter();

            // generate accessible routes map based on roles
            _context.next = 10;
            return dispatch('permission/generateRoutes', roles, {
              root: true
            });
          case 10:
            accessRoutes = _context.sent;
            // dynamically add accessible routes
            _iterator = _createForOfIteratorHelper(accessRoutes);
            try {
              for (_iterator.s(); !(_step = _iterator.n()).done;) {
                accessRoute = _step.value;
                router.addRoute(accessRoute);
              }
            } catch (err) {
              _iterator.e(err);
            } finally {
              _iterator.f();
            }
          case 13:
          case "end":
            return _context.stop();
        }
      }, _callee);
    }));
  }
};
export default {
  namespaced: true,
  state: state,
  mutations: mutations,
  actions: actions
};